var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { IconButton } from "@mui/material";
import clsx from "clsx";
import { forwardRef, useMemo } from "react";
import { UiSpinner } from "../ui_spinner";
import { UiTooltip } from "../ui_tooltip";
import { useStyles } from "./ui_icon_button.css";
export const UiIconButton = forwardRef((_a, ref) => {
    var { children, className, isActive, isLoading, tooltip, TooltipProps } = _a, props = __rest(_a, ["children", "className", "isActive", "isLoading", "tooltip", "TooltipProps"]);
    const classes = useStyles();
    return useMemo(() => {
        var _a;
        return (_jsx(UiTooltip, Object.assign({ title: tooltip || "" }, TooltipProps, { children: _jsx("span", { className: (_a = props.classes) === null || _a === void 0 ? void 0 : _a.wrapper, children: _jsx(IconButton, Object.assign({}, props, { className: clsx(className, isActive && classes.button_active), "data-test-class": "ui-icon-button", ref: ref, children: isLoading ? (_jsx(UiSpinner, { size: 16, sx: { margin: "4px" } })) : (children) })) }) })));
    }, [
        tooltip,
        TooltipProps,
        props,
        className,
        isActive,
        classes.button_active,
        ref,
        isLoading,
        children,
    ]);
});
//# sourceMappingURL=ui_icon_button.js.map